/**
 * The site's default locale: where `/` redirects to, and what an unrecognised
 * locale segment falls back to.
 *
 * This is deliberately separate from the DatoCMS *main* locale (the first entry
 * in Settings -> Locales, currently `en`), which controls translation fallback
 * for unlocalised content. The two serve different purposes and need not match.
 *
 * Kept dependency-free so both server and client components can import it.
 */
export const DEFAULT_LOCALE = "en_GB";

/**
 * Returns the site default if the CMS actually has it, otherwise the CMS main
 * locale — so a typo or a locale removed in DatoCMS degrades instead of
 * producing dead URLs.
 */
export function resolveDefaultLocale<T extends string>(locales: readonly T[]): T {
  return locales.includes(DEFAULT_LOCALE as T) ? DEFAULT_LOCALE as T : locales[0];
}